export default __webpack_public_path__ + "static/media/Holiday INN.4f7eed5a.jpg";